var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masked-input',_vm._g(_vm._b({staticClass:"imd-input-mask",attrs:{"type":"text"}},'masked-input',Object.assign({}, _vm.opt, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }